import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

//#region Whitespace Validator
export const whitespaceValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value;

        if(value && value.trim().length === 0){
           return { whitespace: 'This field cannot contain only spaces.' };
        }
        if (value && (value.startsWith(' ') || value.endsWith(' '))){
            return { whitespace: 'This field cannot contain leading or trailing spaces.' };
        }

        const hasExtraSpaces: boolean = /\s{2,}/.test(value);

        if(hasExtraSpaces){
            return { whitespace: 'This field cannot contain consecutive spaces.' };
        }

        return null;
}
//#endregion Whitespace Validator
